<script>
import RelativeTimeOdds from './RelativeTimeOdds.vue';
import RelativeTimePunters from './RelativeTimePunters.vue';
export default {
  name: 'RelativeTime',
  components: {
    RelativeTimeOdds,
    RelativeTimePunters,
  },
  props: {
    // This prop supports Numbers and Strings! Not sure which is correct
    // eslint-disable-next-line vue/require-prop-types
    targetTime: {
      required: true,
    },
    // odds or punters
    brand: {
      type: String,
      default: 'odds',
    },
    // resulted state for punters relative time
    isResulted: {
      type: Boolean,
      default: false,
    },
    isLegacyFormat: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      currentTime: Date.now(),
    };
  },
  computed: {
    isOdds() {
      return this.brand === 'odds';
    },
    isPunters() {
      return this.brand === 'punters';
    },
  },
  mounted() {
    this.$options.interval = setInterval(this.timer, 1000);
  },
  beforeDestroy() {
    clearInterval(this.$options.interval);
  },
  methods: {
    timer: function() {
      this.currentTime = Date.now();
    },
  },
};
</script>

<template>
  <div class="relative-time">
    <!-- Odds.com.au relative time  -->
    <RelativeTimeOdds
      v-if="isOdds"
      :target-time="targetTime"
      :current-time="currentTime"
      :is-legacy-format="isLegacyFormat"
    />

    <!-- Punters.com.au relative time  -->
    <RelativeTimePunters
      v-if="isPunters"
      :target-time="targetTime"
      :current-time="currentTime"
      :is-resulted="isResulted"
    />
  </div>
</template>
